import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { notificationSettings } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';

const fields: FieldsDefinitions = [
  {
    name: 'emailNotifications',
    label: notificationSettings.emailNotifications,
    bindings: 'TextField',
    value: '',
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
